module.exports = "<div id=\"{{divId}}\" ></div>"